import { useState, useEffect, useMemo } from "react";
import { Modal, Card } from 'react-bootstrap';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Col, Container, Form, Row } from "react-bootstrap";
import PreorderService from "api/precision/PreorderService";
import { useSession } from "context/SessionContext";
import Blank from 'components/support/blank';
import Address from 'control/Address';
import ZoomBox from 'control/ZoomBox';

// http://localhost:3000?token=cecbc0d6c7abb0dcb6f609d8ad6c0b09af1dc87da5ff042b373620ca97fdc4ec&cid=2177&sid=12345&pcid=2218&fid=2
export default function Checkout({ }) {

  const { getProfile, saveProfile, logout } = useSession();
  const [serverCart, setServerCart] = useState(null);
  const [session, setSession] = useState(getProfile());
  const [showModal, setShowModal] = useState(false);

  const handleChange = (ev,) => {
    ev.stopPropagation();
    const name = ev.target.name;
    const value = ev.target.value.trim();
    let ok = true;
    if (name == "quantity") {
      if (value < curProduct.min_quantity) {
        setErrors({ ...errors, [name]: true });
        ok = false;
        ev.target.setAttribute("aria-invalid", "true");
      }
      else {
        setErrors({ ...errors, [name]: false });
        ev.target.setAttribute("aria-invalid", "false");
      }
    }
  };

  const handleOpenModel = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleZoomClick = () => {
    setShowModal(true);
  }

  useEffect(() => {
    document.title = 'Box Sleeve Inqueries';
    fetchPreorders();
  }, []);

  const fetchPreorders = () => {
    const article = {
      "filter": { "customer_id": session.cid, "user_id": 217286 },
      "return": [
        "id", "product_id", "user_id", "description_user_1",
        "quantity", "file_name", "extra", "product"
      ]
    };
    // debugger;
    PreorderService.list(article)
      .then((res) => {
        if (res.data.result == 1) {
          setServerCart(res.data.data);
          console.log(res.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching cart items:", error);
      });
  };


  // Change server cart item quantity
  const handleQntyChange = (e, itemId) => {
    e.stopPropagation();
    // debugger;
    const newQty = e.target.value;
    e.target.classList.remove('is-invalid');
    if (!e.target.checkValidity()) {
      e.target.classList.add('is-invalid');
    }
    setServerCart((prevCartItems) =>
      prevCartItems.map((item) =>
        item.id === itemId ? { ...item, quantity: newQty } : item
      )
    );
  };

  const handleApprove = (e, itemId) => {
    e.stopPropagation();
    setServerCart((prevCartItems) =>
      prevCartItems.map((item) =>
        item.id === itemId ? { ...item, approved: e.target.value } : item
      )
    );
  }

  // Sending approved and rejected cart items back to server
  const handlePlaceOrder = (e) => {
    e.stopPropagation();
    alert("Place order");

    let approvedItems = serverCart.map((item) => {
      if (item.approved) {
        return {
          "preorder_id": item.id, "product_id": item.product_id,
          "user_id": item.user_id,
          "quantity": item.quantity, "approved": item.approved
        }
      }
    });
    const article = {
      "customer_id": session.cid,
      "customer_id": 217286,
      "first_name": null,
      "last_name": null,
      "email": null,
      "delivery_method_id": 1,
      "payment_method_id": 1,
      "shipping_address": null,
      "items": approvedItems
    }

    PreorderService.approve(article)
      .then((res) => {
        if (res.data.result == 1) {
          fetchPreorders();
        }
      })
      .catch((error) => {
        console.error("Error fetching cart items:", error);
      });
  };


  return serverCart ? (
    <div className="psg">
      <h2 className="text-left p-2 ms-3">Box Sleeve Inqueries</h2>
      {
        serverCart.map((item) => (
          <div class="accordion" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id={"header_" + item.id}>
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#inquery_" + item.id} aria-expanded="false">
                  {"inquery #" + item.id}
                  {` - Quanity: ${item.quantity}`}
                  {item.approved ? ` - Status: ${item.approved}` : ""}
                </button>
              </h2>

              <div id={"inquery_" + item.id} class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body p-0">
                  <div className="card card-body see-form m-3">
                    <div className="row">
                      <div className="col-6">
                        <div className="row">
                          <div className="col-sm-5">Contact name:</div>
                          <div className="col-sm-7">{item.extra.contact_name}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">Company Name:</div>
                          <div className="col-sm-7">{item.extra.company_name}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">Customer:</div>
                          <div className="col-sm-7">{item.extra.customer_type}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">Email:</div>
                          <div className="col-sm-7">{item.extra.email}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">Phone:</div>
                          <div className="col-sm-7">{item.extra.phone}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">Street:</div>
                          <div className="col-sm-7">{item.extra.street}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">City:</div>
                          <div className="col-sm-7">{item.extra.city}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">State:</div>
                          <div className="col-sm-7">{item.extra.state}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">Postal Code:</div>
                          <div className="col-sm-7">{item.extra.zip_code}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">Wrapping Paper:</div>
                          <div className="col-sm-7">{item.extra.wrapping_paper}</div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">Candy Assortment:</div>
                          <div className="col-sm-7">{item.extra.candy_assortment}</div>
                        </div>

                      </div>

                      <div className="col-6">
                        <figure className="text-center">
                          <a onClick={handleZoomClick} role="button">
                            <img src={"https://admin.psggo.com/api/resource/2177/preorders/" + item.id + "/image_content.jpeg"} className="img-fluid" />
                          </a>
                          <figcaption className="px-2">{item.product.name}</figcaption>
                        </figure>
                        <ZoomBox
                          srcSmall={"https://www.precisionservicesgroup.com/img/products/previews/" + item.product_id + ".jpg"}
                          srcLarge={"https://www.precisionservicesgroup.com/img/products/previews/" + item.product_id + ".jpg"}
                          showModal={showModal}
                          handleCloseModal={handleCloseModal}
                        />

                        <div className="row justify-content-around" >
                          <label htmlFor={"quantity" + item.id} className="col-4">Quantity*</label>
                          <div className="col-7">
                            <input
                              className="form-control"
                              type="number"
                              id={"quantity" + item.id}
                              name={"quantity" + item.id}
                              min={item.product.min_quantity}
                              max={item.product.max_quantity}
                              value={item.quantity}
                              onChange={(e) => handleQntyChange(e, item.id)}
                            />
                            <div className="invalid-feedback small">Quantity must be greater than {item.product.min_quantity}</div>
                          </div>
                        </div>

                        <div className="row my-2 justify-content-around">
                          <div className="col-4">
                            <label className="form-check-label" htmlFor={"approval" + item.id} >Approval*</label>
                          </div>
                          <div className="col-7">
                            <select className="form-control" id={"approval" + item.id}
                              name={"approval" + item.id}
                              onChange={(e) => handleApprove(e, item.id)}
                              required
                            >
                              <option value=""> </option>
                              <option value="Approve"> Approve </option>
                              <option value="Reject"> Reject </option>
                            </select>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      }
      <div className="row mt-3">
        <div className="col-12 text-center">
          <button type="button" className="btn bg-black text-white rounded-0 ms-auto" onClick={handlePlaceOrder}>Place Order</button>
        </div>
      </div>
    </div>
  ) : <Blank />;
}
